import { AppleStoreIcon, PlayStoreIcon } from '../Utils/SvgIcons'

const AppLinkIconSet = ({appleIconWidth = 35, appleIconHeight = 35, playStoreIconWidth = 30, playStoreIconHeight = 30, border = true}) => {
  return (
    <div className='flex flex-row gap-2 justify-end'>
        <a
            href='https://apps.apple.com/us/app/players-turf-sports-booking/id6738467400'
            className={`cursor-pointer ${border ? 'border border-slate-300' : ''} rounded-full p-1 flex items-center justify-center`}
            target='_blank'
            rel="noopener noreferrer"
        >
            <AppleStoreIcon width={appleIconWidth} height={appleIconHeight} />
        </a>
        <a
            href='https://play.google.com/store/apps/details?id=com.playersturf'
            className={`cursor-pointer ${border ? 'border border-slate-300' : ''} rounded-full p-1 flex items-center justify-center`}
            target='_blank'
            rel="noopener noreferrer"
        >
            <PlayStoreIcon width={playStoreIconWidth} height={playStoreIconHeight} />
        </a>
    </div>
  )
}

export default AppLinkIconSet